let userData = {
  userStates: {
    ok: {
      verboseName: "Active",
      color: "success",
    },
    not_active: {
      verboseName: "Not Active",
      color: "secondary",
    },
    invited: {
      verboseName: "Invited",
      color: "warning",
    },
  },
  allUserTriggers: {
    set_controlpoint: {
      verboseName: "Set Control Point",
      formComponent: "NoteForm",
      userTrigger: true,
    },
    set_race: {
      verboseName: "Set Race",
      formComponent: "NoteForm",
      userTrigger: true,
    },
    activate: {
      verboseName: "Activate User",
      formComponent: "NoteForm",
      userTrigger: true,
    },
    deactivate: {
      verboseName: "Deactivate User",
      formComponent: "NoteForm",
      userTrigger: true,
    },
  },
};

export { userData };